import { render, staticRenderFns } from "./standardMobile.vue?vue&type=template&id=9dcc04d8&scoped=true&"
import script from "./standardMobile.vue?vue&type=script&lang=js&"
export * from "./standardMobile.vue?vue&type=script&lang=js&"
import style0 from "./standardMobile.vue?vue&type=style&index=0&id=9dcc04d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcc04d8",
  null
  
)

export default component.exports